class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    // This is for side shields
    window.shieldsInStock = true;
    if (
      window.location.href.indexOf("preview") > -1 ||
      window.location.href.indexOf("cammina") > -1
    ) {
      window.shieldsInStock = false;
    } else {
      const checkbox = document.querySelector(".add-on-product-checkbox");
      checkbox.addEventListener("change", (event) => {
        this.onVariantChange();
      });
    }
  }

  mobileCheck() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    // console.log("current variant");
    // console.log(this.currentVariant);

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      //this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();

      var option1 = this.currentVariant.option1;
      var option2 = this.currentVariant.option2;
      option2 = option2.replace("Non-", "");
      option2 = option2.replace("Polarized ", "");

      // console.log (option1, option2);

      var alt_text = null;

      if (option1 == "Tortoise" && option2 == "Grey") {
        // Classic
        alt_text = "tortoise_grey";
      } else if (option1 == "Tortoise" && option2 == "Brown") {
        alt_text = "tortoise_brown";
      } else if (option1 == "Tortoise" && option2 == "Yellow") {
        alt_text = "tortoise_yellow";
      } else if (option1 == "Charcoal" && option2 == "Grey") {
        alt_text = "charcoal_grey";
      } else if (option1 == "Charcoal" && option2 == "Brown") {
        alt_text = "charcoal_brown";
      } else if (option1 == "Charcoal" && option2 == "Yellow") {
        alt_text = "charcoal_yellow";
      } else if (option1 == "Matte Brown" && option2 == "Grey") {
        alt_text = "mattebrown_grey";
      } else if (option1 == "Matte Brown" && option2 == "Brown") {
        alt_text = "mattebrown_brown";
      } else if (option1 == "Matte Brown" && option2 == "Yellow") {
        alt_text = "mattebrown_yellow";
      } else if (option1 == "Slate" && option2 == "Grey") {
        // Dolomite
        alt_text = "slate_grey";
      } else if (option1 == "Slate" && option2 == "Brown") {
        alt_text = "slate_brown";
      } else if (option1 == "Slate" && option2 == "Yellow") {
        alt_text = "slate_yellow";
      } else if (option1 == "Ember" && option2 == "Grey") {
        // Leggero
        alt_text = "ember_grey";
      } else if (option1 == "Ember" && option2 == "Brown") {
        alt_text = "ember_brown";
      } else if (option1 == "Ember" && option2 == "Yellow") {
        alt_text = "ember_yellow";
      } else if (option1 == "Tortoise" && option2.indexOf("Blue") >= 0) {
        // Classic - Blue Blockers
        alt_text = "tortoise_blocker";
      } else if (option1 == "Charcoal" && option2.indexOf("Blue") >= 0) {
        alt_text = "charcoal_blocker";
      } else if (option1 == "Matte Brown" && option2.indexOf("Blue") >= 0) {
        alt_text = "mattebrown_blocker";
      } else if (option1 == "Slate" && option2.indexOf("Blue") >= 0) {
        // Dolomite - Blue Blockers
        alt_text = "slate_blocker";
      } else if (option1 == "Ember" && option2.indexOf("Blue") >= 0) {
        // Leggero - Blue Blockers
        alt_text = "ember_blocker";
      } else if (option1 == "Kelp" && option2 == "Yellow") {
        // Kelp Classics
        alt_text = "kelp_yellow";
      } else if (option1 == "Black Ice" && option2 == "Silver Mirror") {
        // Dolomite Black Ice
        alt_text = "black_ice_silver_mirror";
      } else if (option1 == "Dusk" && option2 == "Grey") {
        // Viale
        alt_text = "dusk_grey";
      } else if (option1 == "Dusk" && option2 == "Brown") {
        alt_text = "dusk_brown";
      } else if (option1 == "Dusk" && option2 == "Yellow") {
        alt_text = "dusk_yellow";
      } else if (option1 == "Dusk" && option2.indexOf("Blue") >= 0) {
        alt_text = "dusk_blocker";
      } else if (option1 == "Honey" && option2 == "Grey") {
        // Teton
        alt_text = "honey_grey";
      } else if (option1 == "Honey" && option2 == "Brown") {
        alt_text = "honey_brown";
      } else if (option1 == "Honey" && option2 == "Yellow") {
        alt_text = "honey_yellow";
      } else if (option1 == "Honey" && option2.indexOf("Blue") >= 0) {
        alt_text = "honey_blocker";
      } else if (option1 == "Radavist Kelp" && option2 == "Yellow Polarized") {
        alt_text = "radavist";
      } else if (option1 == "Frost" && option2 == "Grey Mirror") {
        alt_text = "frost_polarized_grey_mirror";
      }

      // console.log( option1 + " " + option2);
      // console.log("alt_text " + alt_text);

      if (window.shieldsInStock) {
        let no_shields = [
          43095874633979, 43095874699515, 43095874765051, 43095933485307,
          43095933550843, 43095933616379, 43095933649147, 43095933518075,
          43095933583611, 43095874666747, 43095874732283, 43095874797819,
          43095933747451, 43095933780219, 43095933812987, 43095933878523,
        ];

        if (no_shields.includes(this.currentVariant.id)) {
          document.getElementById("showid").checked = false;
          document.getElementById("showshields").style.display = "none";
          document.getElementById("noshields").style.display = "block";
        } else {
          // document.getElementById("showid").checked = true;
          document.getElementById("showshields").style.display = "block";
          document.getElementById("noshields").style.display = "none";
        }

        if (document.querySelector(".add-on-product-checkbox").checked) {
          alt_text = alt_text + "_shields";
          //document.querySelector('.shields-hide').style.display = "block";
          var elements = document.getElementsByClassName("shields-hide");
          for (var i = 0; i < elements.length; i++) {
            elements[i].style.display = "block";

            if (i === 0) {
              elements[i].style.color = "white";
              elements[i].style.fontSize = "3.2rem";
            }
          }
          // console.log("alt " + alt_text);
        } else {
          var elements = document.getElementsByClassName("shields-hide");
          for (var i = 0; i < elements.length; i++) {
            elements[i].style.display = "none";
          }
        }
        var shieldstring = "&shield=true";
        var shieldstring = "";
        var querystring =
          "?collection=" + product_swatch_carousel_lens.realIndex;
        if (product_swatch_carousel_lens.realIndex == 4) {
          querystring = "?collection=0";
        }
        if (document.querySelector(".add-on-product-checkbox").checked) {
          querystring = querystring + shieldstring;
          console.log(querystring);
        }
      }

      $(".product-top-list-swiper a").each(function () {
        var href = $(this).attr("href").split("?")[0];
        if (href) {
          $(this).attr("href", href + querystring);
        }
      });

      // Rx variant
      let url = jQuery("#rxbtn").attr("href");
      let dataUrl = jQuery("#rxbtn").data("rx");
      let firsturl = dataUrl.split("-").slice(0, 4).join("-") + "-";
      // jQuery("#rxbtn").attr('href',firsturl + option1.replace(" ","-").toLowerCase());
      // jQuery("#rxshopbtn").attr('href',firsturl + option1.replace(" ","-").toLowerCase());

      // if (option1.replace(" ", "-").toLowerCase() == "honey") {
      //   const changedUrl = firsturl + "charchoal";
      //   const encodedUrl = encodeURIComponent(changedUrl);
      //   const fullurl =
      //     "https://ombraz.com/pages/ombraz-loading/?lensandco=" + encodedUrl;
      //   jQuery("#rxshopbtn").attr("href", fullurl);
      //   jQuery("#rxbtn").attr("href", fullurl);
      // } else {
      console.log(firsturl + option1.replace(" ", "-").toLowerCase());
      const encodedUrl = encodeURIComponent(
        firsturl + option1.replace(" ", "-").toLowerCase()
      );
      console.log(encodedUrl);
      const fullurl =
        "https://ombraz.com/pages/ombraz-loading/?lensandco=" + encodedUrl;
      jQuery("#rxshopbtn").attr("href", fullurl);
      jQuery("#rxbtn").attr("href", fullurl);
      // }
      // console.log(this.currentVariant, alt_text);

      var product_swiper = $(".product-swiper")[0].swiper;
      var product_thumbnail_swiper = $(".product-thumbnail-swiper")[0].swiper;

      $(".product-swiper li")
        .addClass("swiper-slide")
        .removeClass(
          "swiper-slide-active swiper-slide-next swiper-slide-prev swiper-slide-visible non-swiper-slide"
        )
        .show();
      $(".product-thumbnail-swiper li")
        .addClass("swiper-slide")
        .removeClass(
          "swiper-slide-thumb-active swiper-slide-active swiper-slide-next swiper-slide-prev swiper-slide-visible non-swiper-slide"
        )
        .show();

      // $('.product-swiper').find('.swiper-lazy-preloader').remove(); //remove lazy preloader

      $(".product-swiper li").each(function () {
        var item_alt = $(this).find("img").attr("alt");
        // console.log( "item_alt " + item_alt + " alt_text "+alt_text.toLowerCase());

        // console.log("item alt " + item_alt);
        // console.log("alt_text " + alt_text);
        var currentContainsShields = item_alt.toLowerCase().indexOf("shield");
        var perspectiveContainsShields = alt_text
          .toLowerCase()
          .indexOf("shield");

        // let shields = true;
        // if( lower_case_item_alt.indexOf("shield") >= 0 && lower_case_alt_text.indexOf("shield") < 0){
        //   shields = false;

        // }
        //console.log("item_alt "+ item_alt.toLowerCase());
        //console.log("alt_text "+ alt_text.toLowerCase());

        if (
          item_alt != null &&
          item_alt.toLowerCase().indexOf(alt_text.toLowerCase()) >= 0 &&
          currentContainsShields >= 0 == perspectiveContainsShields >= 0
        ) {
          // $(this).find('img').addClass("swiper-lazy");
          // $(this).find(".swiper-zoom-container").append('<div class="swiper-lazy-preloader"></div>');

          $(this).addClass("swiper-slide").show();
        } else {
          $(this)
            .addClass("non-swiper-slide")
            .removeClass("swiper-slide")
            .hide();
        }
      });

      $(".product-thumbnail-swiper li").each(function () {
        var item_alt = $(this).find("img").attr("alt");
        var currentContainsShields = item_alt.toLowerCase().indexOf("shield");
        var perspectiveContainsShields = alt_text
          .toLowerCase()
          .indexOf("shield");
        if (
          item_alt != null &&
          item_alt.toLowerCase().indexOf(alt_text.toLowerCase()) >= 0 &&
          currentContainsShields >= 0 == perspectiveContainsShields >= 0
        ) {
          $(this).addClass("swiper-slide").show();
        } else {
          $(this)
            .addClass("non-swiper-slide")
            .removeClass("swiper-slide")
            .hide();
        }
      });

      if (product_swiper) {
        product_swiper.destroy();
        product_swiper = null;
      }

      if (product_thumbnail_swiper) {
        product_thumbnail_swiper.destroy();
        product_thumbnail_swiper = null;
      }

      console.log("checking for existence of product_thumbnail_swiper");
      if (!product_thumbnail_swiper) {
        console.log("initializing lazy swiper for .product-thumbnail-swiper");
        product_thumbnail_swiper = new Swiper(".product-thumbnail-swiper", {
          spaceBetween: 10,
          slidesPerView: 6,
          loop: false,
          lazy: true,
          breakpoints: {
            320: {
              slidesPerView: 5,
              spaceBetween: 5,
            },
            480: {
              slidesPerView: 5,
              spaceBetween: 5,
            },
            768: {
              slidesPerView: 5,
              spaceBetween: 5,
            },
            1024: {
              slidesPerView: 6,
              spaceBetween: 10,
            },
          },
          on: {
            // LazyLoad swiper images after swiper initialization
            afterInit: (swiper) => {
              new LazyLoad({
                container: swiper.el,
                cancel_on_exit: false,
              });
            },
          },
        });

        console.log("checking for existence of product_swiper");
        if (!product_swiper) {
          console.log("initializing lazy swiper for .product-swiper");
          product_swiper = new Swiper(".product-swiper", {
            zoom: {
              maxRatio: 2,
              toggle: true,
            },
            lazy: true,
            spaceBetween: 10,
            autoHeight: true,

            // Added Smooth fade effect
            speed: 500,
            effect: "fade",
            fadeEffect: {
              crossFade: true,
            },

            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            thumbs: {
              swiper: product_thumbnail_swiper,
            },
            on: {
              // LazyLoad swiper images after swiper initialization
              afterInit: (swiper) => {
                new LazyLoad({
                  container: swiper.el,
                  cancel_on_exit: false,
                });
              },
            },
          });

          $(".product-swiper").css({
            "--swiper-navigation-color": "#6e7b67",
            "--swiper-pagination-color": "#fff",
            "--swiper-preloader-color": "#6e7b67",
            "--swiper-navigation-size": "24px",
          });
        }
      }
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id[]"');
      input.value = this.currentVariant.id;
      // input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        // console.log("test " + source.innerHTML);

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    console.log("hiiii");
    console.log(this.dataset.section);
    const addButtons = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelectorAll('[name="add"]');

    if (!addButtons.length) return;

    for (var i = 0, len = addButtons.length; i < len; i++) {
      if (disable) {
        addButtons[i].setAttribute("disabled", true);
        if (text) addButtons[i].textContent = text;
      } else {
        addButtons[i].removeAttribute("disabled");
        addButtons[i].textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButtons = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelectorAll('[name="add"]');
    if (!addButtons.length) return;
    for (var i = 0, len = addButtons.length; i < len; i++) {
      addButtons[i].textContent = window.variantStrings.unavailable;
      document
        .getElementById(`price-${this.dataset.section}`)
        ?.classList.add("visibility-hidden");
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

// product_swiper.on("slideChange", () => {
//   console.log ('thumb active -> ', product_swiper.activeIndex);
// //   product_thumbnail_swiper.slideTo(product_swiper.activeIndex);

//   if(product_thumbnail_swiper){
//     const stopVideos = () => {
//       jQuery("iframe").attr("allow","");
//       document.querySelectorAll('iframe').forEach(v => {
//       	v.src = v.src
//       });
//     };
//   }

// });
